module.exports = {
      id: "icon-whatsapp-usage",
      viewBox: "0 0 25.91 25.969",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-whatsapp",
      toString: function () {
        return this.url;
      }
    }